import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.ai.GenerateDescriptionByAI';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class GenerateDescriptionByAI extends RpcClass{

    /**
     *  @class GenerateDescriptionByAI
     *  @alias module:src/server/com/silkplm/rpc/ai/GenerateDescriptionByAI.GenerateDescriptionByAI
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param lang {string} 
     * @param brandIntro {string} 
     * @param base64FileData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/fasterxml/jackson/databind/JsonNode.JsonNode>}
     */
     getImageAiDescriptionSync(lang, brandIntro, base64FileData) {
            return RpcClass.rpcCall('/rpc/ai/generate-description-by-a-i/get-image-ai-description-sync', [lang, brandIntro, base64FileData]);
    }
    /** 
     * @async
     * @param lang {string} 
     * @param brandIntro {string} 
     * @param fileInRepository {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository} 
     * @param skipCache {boolean} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object>}
     */
     getImageDescriptionByAi(lang, brandIntro, fileInRepository, skipCache) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/ai/generate-description-by-a-i/get-image-description-by-ai', [lang, brandIntro, fileInRepository, skipCache]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = rawValue
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param lang {string} 
     * @param brandIntro {string} 
     * @param fileInRepository {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository} 
     * @param part {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     getImageDescriptionByAiSinglePart(lang, brandIntro, fileInRepository, part) {
            return RpcClass.rpcCall('/rpc/ai/generate-description-by-a-i/get-image-description-by-ai-single-part', [lang, brandIntro, fileInRepository, part]);
    }
    /** 
     * @async
     * @param lang {string} 
     * @param brandIntro {string} 
     * @param fileInRepository {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository} 
     * @param skipCache {boolean} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     getImageDescriptionByAiV2(lang, brandIntro, fileInRepository, skipCache) {
            return RpcClass.rpcCall('/rpc/ai/generate-description-by-a-i/get-image-description-by-ai-v2', [lang, brandIntro, fileInRepository, skipCache]);
    }
    /** 
     * @async
     * @param lang {string} 
     * @param input {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     translateToOrganizationLanguage(lang, input) {
            return RpcClass.rpcCall('/rpc/ai/generate-description-by-a-i/translate-to-organization-language', [lang, input]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.ai.GenerateDescriptionByAI';
metadata.__type_short__ = 'GenerateDescriptionByAI';
GenerateDescriptionByAI.prototype.__metadata__ = metadata;

GenerateDescriptionByAI.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/ai/GenerateDescriptionByAI */
export default GenerateDescriptionByAI

export { GenerateDescriptionByAI }
